export default __webpack_public_path__ + "static/media/Automated.3d8d0c17.png";